import React from 'react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

type Props = {
  onClick: () => void;
  // Shows a spinner and disables the button while the next page is being fetched
  isLoading?: boolean;
};

/**
 * A compact load-more button rendered directly beneath the notification list, which loads the next page
 * of notifications on click. Click-driven (rather than scroll-driven) so the "View Archive" card at the
 * bottom of the page stays reachable without the list growing underneath the user.
 */
export function LoadMoreNotificationsCard({ onClick, isLoading = false }: Props) {
  const { t } = useTranslation();

  return (
    <Button
      data-testid="load-more-notifications-btn"
      onClick={onClick}
      isLoading={isLoading}
      variant="ghost"
      size="sm"
      w="100%"
      // Pull up against the list above so it reads as part of it (the list ends with ~20px of margin)
      mt={-3}
      mb={2}
      color="customGrey.400"
      fontWeight="normal"
      rightIcon={<ChevronDownIcon w={5} h={5} />}
    >
      {t('Notifications.load more notifications')}
    </Button>
  );
}
